import { render, staticRenderFns } from "./direct-krw-market.vue?vue&type=template&id=198e7f2d&scoped=true&"
import script from "./direct-krw-market.vue?vue&type=script&lang=js&"
export * from "./direct-krw-market.vue?vue&type=script&lang=js&"
import style0 from "./direct-krw-market.vue?vue&type=style&index=0&id=198e7f2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e7f2d",
  null
  
)

export default component.exports